import { render, staticRenderFns } from "./ApproverDeptRestrictions.vue?vue&type=template&id=10af1f55&scoped=true&"
import script from "./ApproverDeptRestrictions.vue?vue&type=script&lang=js&"
export * from "./ApproverDeptRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./ApproverDeptRestrictions.vue?vue&type=style&index=0&id=10af1f55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af1f55",
  null
  
)

/* custom blocks */
import block0 from "@/locales/components/RequestNotificationStepsConfigTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-request-notification-steps-config%2FApproverDeptRestrictions.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports